<div [ngClass]="classes" [ngStyle]="{'transform': transform, 'white-space': whiteSpaceStyle }">{{prefix}}{{widget.translationName+'.'+fieldName | rdTranslate}}{{suffix}}</div>
